import { FormConsentDropdownValues } from "@/components/site-builder/modules/CustomFormModule/constants";
import { FormBuilderConsentFieldNames } from "@/constants/form-builder";

const transformValue = (value: unknown): boolean | undefined => {
  if (typeof value === "boolean") return value;
  if (value === FormConsentDropdownValues.Yes) return true;
  if (value === FormConsentDropdownValues.No) return false;
  return undefined;
};

export const transformConsentValues = (
  combinedResponse: unknown,
  marketingResponse: unknown,
  thirdPartyResponse: unknown,
): Record<string, boolean> => {
  const result: Record<string, boolean> = {};

  const combinedTransformed = transformValue(combinedResponse);
  if (combinedTransformed !== undefined) {
    result[FormBuilderConsentFieldNames.CombineMarketing] = combinedTransformed;
  }

  const marketingTransformed = transformValue(marketingResponse);
  if (marketingTransformed !== undefined) {
    result[FormBuilderConsentFieldNames.ThirdParty] = marketingTransformed;
  }

  const thirdPartyTransformed = transformValue(thirdPartyResponse);
  if (thirdPartyTransformed !== undefined) {
    result[FormBuilderConsentFieldNames.Marketing] = thirdPartyTransformed;
  }

  return result;
};
